export const SPOT_HIDE_BELOW_STORAGE_KEY = "liveTradesHideSpotBelow";
export const SPOT_DISPLAY_COIN_STORAGE_KEY = "liveTradesSpotDisplayCoin";

/** Backend field for spot quote coin preference. */
export const SPOT_DISPLAY_COIN_API_PARAM = "spotQuotePreference";

export const SPOT_HIDE_BELOW_OPTIONS = [
  "Show all",
  "$1",
  "$2",
  "$3",
  "$4",
  "$5",
];

export const SPOT_DISPLAY_COIN_OPTIONS = ["USDT", "USDC", "FDUSD"];

export const optionToSpotHideValue = (option) => {
  if (option === "Show all") return "0";
  const num = Number(String(option).replace(/[^\d]/g, ""));
  return [1, 2, 3, 4, 5].includes(num) ? String(num) : "0";
};

export const spotHideValueToOption = (value) => {
  const num = Number(value);
  if ([1, 2, 3, 4, 5].includes(num)) return `$${num}`;
  return "Show all";
};

export const normalizeSpotDisplayCoin = (value) => {
  const coin = String(value || "").toUpperCase().trim();
  return SPOT_DISPLAY_COIN_OPTIONS.includes(coin) ? coin : "USDT";
};

const isMemberUser = (user) =>
  user?.role === "member" ||
  user?.role === "memberNoLink" ||
  Boolean(user?.memberNoLink);

/** Members inherit their leader's quote coin — they cannot set their own. */
export const getLeaderSpotDisplayCoin = (user) => {
  const community = user?.memberCommunities?.[0]?.community;
  const leader =
    community?.leader ||
    community?.leaderUser ||
    user?.mainLeader ||
    null;

  const candidates = [
    leader?.spotQuotePreference,
    leader?.[SPOT_DISPLAY_COIN_API_PARAM],
    community?.spotQuotePreference,
    community?.[SPOT_DISPLAY_COIN_API_PARAM],
  ];

  for (const candidate of candidates) {
    if (candidate) return normalizeSpotDisplayCoin(candidate);
  }
  return null;
};

export const getSpotLiveTradeHideBelow = (user) => {
  const fromUser = Number(
    user?.spotHideAssetsBelowUsd ?? user?.spotLiveTradeHideBelow
  );
  if ([1, 2, 3, 4, 5].includes(fromUser)) return fromUser;
  try {
    const fromStorage = Number(
      localStorage.getItem(SPOT_HIDE_BELOW_STORAGE_KEY)
    );
    if ([1, 2, 3, 4, 5].includes(fromStorage)) return fromStorage;
  } catch (_) {
    // ignore
  }
  return 0;
};

export const getSpotDisplayCoin = (user) => {
  // Members always follow their leader's coin preference
  if (isMemberUser(user)) {
    const fromLeader = getLeaderSpotDisplayCoin(user);
    if (fromLeader) return fromLeader;
    return "USDT";
  }

  const fromUser =
    user?.spotQuotePreference ?? user?.[SPOT_DISPLAY_COIN_API_PARAM];
  if (fromUser) return normalizeSpotDisplayCoin(fromUser);
  try {
    const fromStorage = localStorage.getItem(SPOT_DISPLAY_COIN_STORAGE_KEY);
    if (fromStorage) return normalizeSpotDisplayCoin(fromStorage);
  } catch (_) {
    // ignore
  }
  return "USDT";
};

export const persistSpotLiveTradeHideBelow = (hideBelow) => {
  try {
    localStorage.setItem(SPOT_HIDE_BELOW_STORAGE_KEY, String(hideBelow || 0));
  } catch (_) {
    // ignore
  }
};

export const persistSpotDisplayCoin = (coin) => {
  try {
    localStorage.setItem(
      SPOT_DISPLAY_COIN_STORAGE_KEY,
      normalizeSpotDisplayCoin(coin)
    );
  } catch (_) {
    // ignore
  }
};
